(function($){
    
  function clickPagination() {
  	$('.snize-pagination a[data-no-instant="true"], .snize-main-panel-dropdown-content a').click(function(){
      
      $('.snize-button').addClass('loading');
      buildButton();
    });
  }
  
  function checkboxValueChange() {
    $('.snize-product-filters-checkbox').change(function(){
      
      $('.snize-button').addClass('loading');
      buildButton();
    });
  }
  
  function inputValueChange() {
    $('.pointer').on('dragstart mousedown touchstart', function(){
      
      $('#snize_slider_price').trigger('change');
    });
    
    $('.snize-range-slider').on('change', function(){
      
      $('.snize-button').addClass('loading');
      buildButton();
    });
  }
  
  function removeFilter(){
    $('.snize-product-filters-reset').unbind('click').bind('click', function(){
      
      $('.snize-button').addClass('loading');
      buildButton();
    });
  }
  
  function getButton(){
    
    $('.snize-product').each(function(index){
      var snizeProductHandle = $(this).find('a.snize-view-link')?.attr('href').replace(window.location.origin + '/products/', '');
      
      var self = $(this);
      
      $.ajax({
        type: "get",
        url: '/products/' + snizeProductHandle + '?view=json',

        success: function (data) {
          var newButton = $(data).find('.action');
          
          self.find('.snize-add-to-cart-button').replaceWith(newButton.html());
          self.find('button, a.btn').addClass('snize-button');
          var cloneDiv = self.find(".snize-overhidden").clone();
          self.find(".snize-view-link").after(cloneDiv.html());
          self.find(".snize-overhidden").remove();
          querySelectorFunction();
        },

        error: function (xhr, text) {
          console.log('error');
        }
      });
    });
  }
  
  function buildButton(){
     var timeoutid = window.setInterval(function(){
    
      if($('.snize-button').length > 0 && $('.snize-button.loading').length == 0) {
        
        $('.snize-add-to-cart-button').hide();
        
        getButton();
        clickPagination();
        checkboxValueChange();
        inputValueChange();
        removeFilter();

        window.clearInterval(timeoutid);
      }
    }, 100);
  }
  
  buildButton();
  querySelectorFunction();
    
  
})(jQuery)